import { render, staticRenderFns } from "./manualApproveAffiliate.vue?vue&type=template&id=464aaec7&lang=pug"
import script from "./manualApproveAffiliate.vue?vue&type=script&lang=js"
export * from "./manualApproveAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports